import * as Yup from 'yup';


export const RagisterSchema = Yup.object({
    name: Yup.string().min(3).required('Name is Required'),
    email: Yup.string().email().required('Email is Required'),
    phoneNumber: Yup.string().matches(/^[0-9]+$/, 'Must be only digits').min(10, 'Must be exactly 10 digits').max(10, 'Must be exactly 10 digits').required('Phone number is required'),
    password: Yup.string().min(8).required('Password is required'),
    confirmpassword: Yup.string().oneOf([Yup.ref('password'), null], 'Passwords must match').required('Confirm Password is Required'),
})